export const toggleSidebarMobile = () => {
  const sidebar = document.querySelector(".account-sidebar");
  if (sidebar) {
    sidebar.classList.toggle("active");
  }
};
